import getRailsType from './getRailsType';

export const checkMatchingType = (likeableType, itemType) => {
  if (likeableType === 'user-post') {
    return getRailsType(likeableType) === ('Post' || 'Posts::TopicPost');
  }

  return getRailsType(likeableType) === getRailsType(itemType);
};

const increaseLikes = (element, like) => ({
  ...like,
  count: element.likes.count + 1,
});

const decreaseLikes = (element) => ({
  ...element.likes,
  count: element.likes.count - 1,
  id: null,
});

export const updateLikesItem = ({ element, like, increaseCount }) => {
  if (increaseCount) {
    return increaseLikes(element, like);
  }

  return decreaseLikes(element);
};

export const updateLikesInTheRightItem = ({
  element,
  like,
  likeableId,
  type,
  increaseCount,
}) => {
  /* toString() : fix for Jira ticket [https://hivebrite.atlassian.net/browse/PS-1109],
  from the db, some ids are number some are string, need to be fix in BE side */
  if (
    element.id?.toString() === likeableId?.toString() &&
    checkMatchingType(type, element.type) &&
    increaseCount
  ) {
    return increaseLikes(element, like);
  }
  /* toString() : fix for Jira ticket [https://hivebrite.atlassian.net/browse/PS-1109],
  from the db, some ids are number some are string, need to be fix in BE side */
  if (
    element.id?.toString() === likeableId?.toString() &&
    checkMatchingType(type, element.type) &&
    !increaseCount
  ) {
    return decreaseLikes(element);
  }

  return element.likes;
};

export const updateItemsLikes = ({
  setItems,
  likeableId,
  type,
  like = null,
  increaseCount,
}) => {
  setItems((prevState) =>
    prevState.map((element) => ({
      ...element,
      likes: updateLikesInTheRightItem({
        element,
        like,
        likeableId,
        type,
        increaseCount,
      }),
    })),
  );
};

export const updateCurrentNewItemLikes = ({
  setCurrentNewItem,
  increaseCount,
  like = null,
}) => {
  setCurrentNewItem((prevState) => ({
    ...prevState,
    likes: updateLikesItem({
      element: prevState,
      like,
      increaseCount,
    }),
  }));
};
